import axiosInstance from "../Utils/axiosInstance";
import { NotesApi } from "../Constants/api";

export const getNoteModelsApi = async (id, params = {}) => {
  try {
    const searchParams = new URLSearchParams(params);
    const response = await axiosInstance.get(
      `${NotesApi}/${id}/models?${searchParams.toString()}`
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
